import React from 'react';
import SimpleReportForm from '../SimpleReportForm';
import GSTINAdvancedOutputComponent from '../output/GSTINAdvancedOutputComponent';

/**
 * GSTIN Advanced verification.
 *
 * Rendered two ways:
 *   1. Standalone at /app/reports/gstin-advanced/:serviceId — no props, and
 *      SimpleReportForm falls back to useParams() for the serviceId.
 *   2. Embedded in the Lead Wizard's smart-prefill drawer — the parent passes
 *      serviceId/serviceDetails explicitly because the drawer's URL carries no
 *      :serviceId param. The prop wins; the URL is only the fallback.
 *
 * Props are forwarded rather than fixed so the embedded case can also seed the
 * GSTIN from lead data and attach the report to a lead.
 */
const GSTINAdvancedInputComponent = ({
    serviceId,
    serviceDetails,
    leadId,
    initialValues,
    initialReportData,
} = {}) => (
    <SimpleReportForm
        serviceId={serviceId}
        serviceDetails={serviceDetails}
        leadId={leadId}
        initialValues={initialValues}
        initialReportData={initialReportData}
        banner={{ icon: 'pi-verified', title: 'GSTIN Advanced Verification', subtitle: 'Comprehensive GSTIN search with detailed registration data' }}
        fields={[
            { name: 'gstinNumber', label: 'GSTIN Number', icon: 'pi-verified', placeholder: 'e.g. 08AKWPJ1234H1ZN', maxLength: 15, autoCapitalize: 'characters', spellCheck: false, uppercase: true, mono: true,
              regex: /^\d{2}[A-Z]{5}\d{4}[A-Z][1-9A-Z]Z[0-9A-Z]$/, regexError: 'Invalid GSTIN format', colClass: 'col-12 md:col-6 lg:col-5' },
        ]}
        endpoint={{
            path: '/surepass/gstin-advanced',
            bodyMapper: (v, sid) => ({ id_number: v.gstinNumber, api_provider_service_id: parseInt(sid, 10) }),
        }}
        consentReportType="gstin-advanced"
        submitLabel="Run Advanced Search"
        successSummary="GSTIN advanced fetched"
        errorSummary="GSTIN advanced search failed"
        confirmHeader="Confirm advanced GSTIN search"
        confirmAcceptLabel="Yes, search"
        outputComponent={GSTINAdvancedOutputComponent}
        pdfEndpoint={(reportId) => `/surepass/gstin-advanced/${reportId}/generate-pdf`}
        pdfPasswordHint='PDF is password protected — use the last 6 characters of the GSTIN + "GST" (e.g. 58B1ZSGST).'
    />
);

export default GSTINAdvancedInputComponent;
